import { TextInput } from '@mantine/core';
import { IFormInputSpecDeviceProperty } from 'pages/revisions-module/template-editor/editors/form/types';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { RevisionFieldProps } from 'components/forms/revision/fill-out/types';

/**
 * Device property field input for the revision form.
 */
export default function RevisionFieldDeviceProperty({ spec, name }: RevisionFieldProps<IFormInputSpecDeviceProperty>) {
  const { form } = useFillOutRevisionDataProvider();

  return (
    <TextInput
      size="lg"
      name={name}
      label={spec.label}
      required={spec.required}
      readOnly={spec.readOnly}
      {...form.getInputProps(name)}
    />
  );
}
